import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
// eslint-disable-next-line no-unused-vars
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useUsersList() {
  // Use toast
  const toast = useToast()

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    // { key: 'report', sortable: true },
    // { key: 'bu', sortable: true },
    // { key: 'nik', sortable: true },
    // { key: 'nama', sortable: true },
  ]

  // tableColumns.push({ key: 'nik', sortable: true })
  const perPage = ref(100)
  const totalData = ref(0)
  const dataresponse = []
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('nama')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const toFilter = ref(null)
  const fromFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalData.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, fromFilter, toFilter, planFilter, statusFilter], () => {
    refetchData()
  })

  const fetchData = (ctx, callback) => {
    store
      .dispatch('app-user/fetchData', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        report: roleFilter.value,
        tgl_from: fromFilter.value,
        tgl_to: toFilter.value,
        shift: planFilter.value,
        duration: statusFilter.value,
      })
      .then(response => {
        // const { users, total } = response.data

        callback(response.data.data)
        totalData.value = response.data.count
        dataresponse.push(response.data.data)

        tableColumns.length = 0

        tableColumns.push({ key: 'report', sortable: true })
        tableColumns.push({ key: 'bu', sortable: true })
        tableColumns.push({ key: 'nik', sortable: true })
        tableColumns.push({ key: 'nama', sortable: true })

        for (const key in response.data.data[0]) {
          // console.log(key)
          tableColumns.push({ key, sortable: true })
        }
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching Data',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  console.log(dataresponse)
  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 'active') return 'success'
    if (status === 'inactive') return 'secondary'
    return 'primary'
  }

  // taskLocal
  // ------------------------------------------------
  const taskLocal = ref([])
  const resetTaskLocal = () => {
    taskLocal.value = []
  }
  // watch(props.task, () => {
  //   resetTaskLocal()
  // })

  return {
    taskLocal,
    resetTaskLocal,

    fetchData,
    tableColumns,
    perPage,
    currentPage,
    totalData,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    roleFilter,
    fromFilter,
    toFilter,
    planFilter,
    statusFilter,
  }
}
